export default __webpack_public_path__ + "static/media/flame.4f2e0757.svg";